define(["jquery", "site/TEKsystems.SitecoreXP.Common"], function ($, Common) {
    function Init() {
        var headerHeight = 50;
        if ($("header").length > 0) {
            headerHeight += $("header").height();
        }

        if ($(".tek-progress-bar-nav").length > 0) {
            headerHeight += $(".tek-progress-bar-nav").height();
        }

        $("a[name]").css("scroll-margin-top", headerHeight + "px");

        var anchor = Common.URL.GetParameterByName("anchor");

        if (anchor) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $("a[name='" + anchor + "']").offset().top - headerHeight
            }, 0);
        }
    }

    return {
        Init: Init
    };
});